import React from 'react';
import { mergeSx } from '@jucy-ui/appearance';
import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingProps {
    text?: string;
    sx?: SxProps<Theme>;
}

const Loading: React.FC<React.PropsWithChildren<LoadingProps>> = ({ children, text, sx }) => (
    <Box
        sx={mergeSx(
            (theme) => ({
                padding: theme.spacing(4, 2, 2, 2),
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }),
            sx
        )}
    >
        <CircularProgress sx={(theme) => ({ marginBottom: theme.spacing(1) })} />
        {text}
        {children}
    </Box>
);

export default Loading;
